<div class="main-container">

  <div class="title">
    <span class="title-text">Admin Requisitions</span>
    <p class="small-title">Forwarded / to-cancel requisitions handled by the admin.</p>
  </div>

  <div class="head-actions">
    <button type="button" class="ac-secondary-btn" (click)="load()">Refresh</button>
    @if(canRollbackAll){
    <button type="button" class="ac-danger-btn" (click)="bulkRollback()">Roll back aged locks</button>
    }
  </div>

  <!-- PENDING -->
  <div class="section-title">Pending (forwarded)</div>
  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr>
          <th>Booking ID</th><th>Family Code</th><th>Category</th><th>Type</th>
          <th>Mode</th><th>Status</th><th>Stage</th>
          @if(canLock){ <th>Action</th> }
        </tr>
      </thead>
      <tbody class="table-body">
        @for(row of pending; track row.requisitionId){
        <tr>
          <td>{{ row.requisitionId }}</td>
          <td>{{ row.familyCode }}</td>
          <td>{{ row.requisitionCategory || '-' }}</td>
          <td>{{ row.requisitionType || '-' }}</td>
          <td>{{ row.requisitionMode || '-' }}</td>
          <td>{{ row.requisitionStatus }}</td>
          <td>{{ row.requisitionLifecycleStatus }}</td>
          @if(canLock){
          <td><button type="button" class="ac-secondary-small-btn" (click)="open(row)">Open</button></td>
          }
        </tr>
        }
        @if(!isLoading && pending.length === 0){
        <tr><td [attr.colspan]="canLock ? 8 : 7" class="empty-row">No pending admin requisitions.</td></tr>
        }
      </tbody>
    </table>
  </div>

  <!-- CONFIRMED TO CANCEL -->
  <div class="section-title">Confirmed — to cancel</div>
  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr>
          <th>Booking ID</th><th>Family Code</th><th>Category</th><th>Type</th>
          <th>Mode</th><th>Status</th><th>Stage</th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for(row of confirmed; track row.requisitionId){
        <tr>
          <td>{{ row.requisitionId }}</td>
          <td>{{ row.familyCode }}</td>
          <td>{{ row.requisitionCategory || '-' }}</td>
          <td>{{ row.requisitionType || '-' }}</td>
          <td>{{ row.requisitionMode || '-' }}</td>
          <td>{{ row.requisitionStatus }}</td>
          <td>{{ row.requisitionLifecycleStatus }}</td>
        </tr>
        }
        @if(!isLoading && confirmed.length === 0){
        <tr><td colspan="7" class="empty-row">No confirmed bookings to cancel.</td></tr>
        }
      </tbody>
    </table>
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
